import { connect } from 'react-redux';
import { State } from 'store/state';
import { manageListingsErrorModalSelector } from 'store/state/app/selectors';
import { closeManageListingsErrorModal } from 'store/state/app/actions';
import { ErrorModal } from './ErrorModal';
import * as actions from 'store/state/router/actions';
import { isAgentConsoleUserSelector, userWithReducedListingLimitSelector } from 'store/state/domainData/selectors';
import { initialValuesSelector } from 'screens/EditBulletinPage/utils';
import { routeSelector } from 'store/state/selectors/router';


const mapStateToProps = (state: State) => ({
  data: manageListingsErrorModalSelector(state),
  userWithReducedListingLimit: userWithReducedListingLimitSelector(state),
  initialEditValues: initialValuesSelector(state),
  isAgentConsoleUser: isAgentConsoleUserSelector(state),
  route: routeSelector(state),
});

const mapDispatchToProps = {
  onClose: closeManageListingsErrorModal,
  navigateTo: actions.navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
